export default __webpack_public_path__ + "static/texturering-56634b7b012ea0d7b0477bf6dd6b0d2b.png";